export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/1l.90430ab4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};